<template>
  <v-card>
    <v-card-text>
      <v-container>
        <v-container v-if="phaseType == 'planning' || phaseType == 'all'">
          <v-row class="justify-center paddingTop10">
            <div class="text-h5">{{ $t('Budget') }}</div>
          </v-row>
          <v-row>
            <!--<v-col
              cols="12"
              md="2"
            >
              <v-text-field 
                v-if="formType == 'editForm' && phaseType == 'planning'"
                v-model="proj.project_number"
                color="purple"
                type="number"
                :label="$t('Project Id')"
              />
              <div v-if="phaseType == 'all'">
                <p>{{ $t('Project Id') }}</p>
                <p class="text-h4 text--primary">{{ proj.project_number }}</p>
              </div>
            </v-col>-->
            <v-col
              cols="12"
              md="2"
            >
              <div>
                <p>{{ $t('Assessed Value (mLAK)') }}</p>
                <p class="text-h4 text--primary">{{ proj.estimated_cost.toLocaleString('en-US') }}</p>
              </div>
            </v-col>
            <v-col
              cols="12"
              md="3"
            >
              <v-text-field 
                v-if="formType == 'editForm' && phaseType == 'planning'"
                v-model="proj.national_assembly_cost"
                color="purple"
                type="number"
                :label="$t('National Assembly Value (mLAK)')"
                :hint="$t('Positive Number is required')"
                :rules="numberRules"
                persistent-hint
              />
              <div v-if="phaseType == 'all'">
                <p>{{ $t('National Assembly Value (mLAK)') }}</p>
                <p class="text-h4 text--primary">{{ proj.national_assembly_cost }}</p>
              </div>
            </v-col>
            <v-col
              cols="12"
              md="3"
            >
              <v-text-field 
                v-if="formType == 'editForm' && phaseType == 'planning'"
                v-model="proj.contract_cost"
                color="purple"
                type="number"
                :label="$t('Contract Value (mLAK)')"
                :hint="$t('Positive Number is required')"
                :rules="numberRules"
                persistent-hint
              />
              <div v-if="phaseType == 'all'">
                <p>{{ $t('Contract Value (mLAK)') }}</p>
                <p class="text-h4 text--primary">{{ proj.contract_cost }}</p>
              </div>
            </v-col>
            <v-col
              cols="12"
              md="3"
            >
              <v-text-field 
                v-if="formType == 'editForm' && phaseType == 'planning'"
                v-model="proj.budget_current_year"
                color="purple"
                type="number"
                :label="$t('Budget Current Year (mLAK)')"
                :hint="$t('Positive Number is required')"
                :rules="numberRules"
                persistent-hint
              />
              <div v-if="phaseType == 'all'">
                <p>{{ $t('Budget Current Year (mLAK)') }}</p>
                <!--<p class="text-h4 text--primary">{{ budget.budget_current_year[0].amount.toLocaleString() }}</p>--> 
                <p class="text-h4 text--primary" v-if="proj.budget_current_year">{{ proj.budget_current_year }} ( {{ new Date().getFullYear() +1 }} )</p>
              </div>
            </v-col>
            <v-col
              cols="12"
              md="1"
            >
              <p v-if="formType == 'editForm' && phaseType == 'planning' && new Date(proj.project_start_date).getFullYear() < new Date().getFullYear()">{{ $t('On Debt') }}</p>
              <input v-if="formType == 'editForm' && phaseType == 'planning' && new Date(proj.project_start_date).getFullYear() < new Date().getFullYear()" type="checkbox" v-model="proj.on_debt">
              <div v-if="phaseType == 'all'">
                <p>{{ $t('On Debt') }}</p>
                <p class="text-h4 text--primary"><v-icon v-if="proj.on_debt">mdi-check</v-icon></p>
              </div>
            </v-col>
          </v-row>
        </v-container>

        <v-container v-if="phaseType == 'reporting' || phaseType == 'all'">
          <v-row>
            <v-col
                cols="12"
                md="6"
            >
              <v-row class="justify-center pt-3">
                <div class="text-h5">{{ $t('Budget Current Year (mLAK)') }}</div>
              </v-row>
              <v-row class="d-flex align-center ma-auto mt-5 mb-5 add-button">
                <v-col
                    cols="12"
                    class="d-flex flex-column align-center ma-auto "
                  > 
                  <div>
                    <table>
                      <tr class="text-h4 text--primary" v-for="budget in proj.budget_current_years">
                        <td> {{ budget.amount.toLocaleString('en-US') }} ({{ budget.year.name }}) </td>
                      </tr>
                    </table>
                  </div>
                </v-col>
              </v-row>
            </v-col>

            <v-col
                cols="12"
                md="6"
            >
              <v-row class="justify-center pt-3">
                <div class="text-h5">{{ $t('Other Fund (mLAK)') }}</div>
              </v-row>

              <v-row class="d-flex align-center ma-auto mt-5 mb-5 add-button"> 
                  <v-col
                    cols="12"
                    class="d-flex flex-column align-center ma-auto "
                  > 
                    <div v-if="(phaseType == 'reporting' || phaseType == 'all') && proj.project_budget_other_funding.length !== 0">
                      <table>
                        <tr class="text-h4 text--primary" v-for="fund in proj.project_budget_other_funding">
                          <td> {{ fund.amount.toLocaleString('en-US') }} ({{ new Date( fund.createdAt).toLocaleDateString("en-GB") }}) </td>
                          <td v-if="phaseType == 'reporting' && $store.state.auth.user.user_functions[8].user_type_id === 3">
                              <v-btn style="height: 24px;padding:0;margin:1px;" color="primary" v-on:click="dropModal('Fund', 'Fund ' + fund.amount + 'mLAK' + ' (' + new Date( fund.createdAt).toLocaleDateString('en-GB') + ')', fund.id, null)">
                                <v-icon style="font-size: 19px;">mdi-delete</v-icon>
                              </v-btn>
                          </td>
                        </tr>
                      </table>
                      <!--<p class="text-h4 text--primary" v-for="fund in proj.project_budget_other_funding">{{ fund.amount.toLocaleString() }} ({{ new Date( fund.createdAt).toLocaleDateString("en-GB") }})</p>-->
                      <v-dialog v-model="dialog_delete_fund" max-width="1700px" :retain-focus="false">
                      <DeleteForm 
                        v-if="dialog_delete_fund"
                        :type="modal.type" 
                        :name="modal.name" 
                        :element="modal.element" 
                        :dialog.sync="dialog_delete_fund" 
                        @deleteMessage="getDeleteModalFundAnswer"/>
                  </v-dialog>

                    </div>

                    <v-btn v-if="!add_fund_flag && phaseType == 'reporting' && $store.state.auth.user.user_functions[8].user_type_id !== 1"
                      prepend-icon="mdi-plus" 
                      class="add-button add-button-other-fund"
                      color="blue" dark relative right
                      v-on:click="newFundForm();">
                      <v-icon>mdi-plus</v-icon>
                      {{ $t('Add Other Fund') }}
                    </v-btn>

                    <v-row v-if="add_fund_flag">
                      <v-text-field 
                        v-model="proj.other_budget_amount"
                        color="purple"
                        type="number"
                        :label="$t('Other Fund (mLAK)')"
                        :hint="$t('Mandatory')"
                        :rules="numberRules"
                        persistent-hint
                      />
                     <v-btn 
                        class="close-button"
                        text
                        v-on:click="closeNewFundForm()"
                      >
                        {{ $t('Close') }}
                      </v-btn>
                      <v-btn
                        color="white darken-1"
                        style="background-color:#31c0be;"
                        text
                        v-on:click="saveNewFund()"
                        v-if="proj.other_budget_amount > 0"
                      >
                        {{ $t('Save') }}
                      </v-btn>
                    </v-row>

                  </v-col>

              </v-row>
            </v-col>
          </v-row>
        <v-row class="justify-center" v-if="phaseType == 'reporting' || phaseType == 'all' ">
          <div class="text-h5">{{ $t('Payment') }}</div>
        </v-row>

        <material-card v-if="phaseType == 'reporting' || phaseType == 'all' ">

          <v-simple-table class="expense-table mb-8">
            <thead>
              <tr>
                <th>{{ $t('Work Performed (mLAK)') }}</th>
                <th>{{ $t('Payment (mLAK)') }}</th>
                <th>{{ $t('Date') }}</th>
                <th>{{ $t('Document') }}</th>
                <th>{{ $t('Regular Fund') }}</th>
                <th v-if="phaseType == 'reporting' && $store.state.auth.user.user_functions[8].user_type_id !== 1">{{ $t('Update') }}</th>
                <th v-if="phaseType == 'reporting' && $store.state.auth.user.user_functions[8].user_type_id === 3">{{ $t('Delete') }}</th>
              </tr>
            </thead>
            <tbody>

              <!-- Itération sur le tableau principal -->
              <template v-for="(work,workIndex) in proj.project_works">
                <!-- Itération sur les dépenses de chaque travail -->
                <tr v-for="(expense, expenseIndex) in work.work_expenses" 
                    :key="'expense-' + expense.id"
                    :class="{ 'no-border': isSameWorkBelow(workIndex, expenseIndex) }">
                  <td v-if="expenseIndex === 0">
                      {{ expense.work_value }}


                      <!--<v-btn v-if="!add_fund_flag && phaseType == 'reporting' && $store.state.auth.user.user_functions[8].user_type_id !== 1 && proj.project_status_id !== 2"
                      prepend-icon="mdi-plus" 
                      color="blue" dark relative right
                      v-on:click="newFundForm();">
                      <v-icon>mdi-plus</v-icon>
                      {{ $t('Add Other Fund') }}
                    </v-btn>-->

                      <v-dialog v-model="dialog_add_expense" max-width="1700px" :retain-focus="false">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn class="add-button add-button-expense" color="blue" v-bind="attrs" v-on="on" dark relative left v-on:click="addExpense(proj, proj.project_works[workIndex])">
                              <v-icon>mdi-plus</v-icon>
                              {{ $t('Payment') }}
                            </v-btn>
                        </template>
                        <ExpenseForm 
                            v-if="dialog_add_expense"
                            :expense="expense_details" 
                            :formType="'addForm'" 
                            :dialog.sync="dialog_add_expense" />
                      </v-dialog>
                  </td> 
                  <td v-if="expenseIndex !== 0"></td>
                  <td>{{ expense.expense_amount }}</td> 
                  <td>{{ new Date(expense.createdAt).toLocaleDateString("en-GB") }}</td>
                  <td> <span class="hyperlink_document" v-on:click="download(expense, proj.id)">{{ expense.document_name }}</span></td>
                  <td>
                    <span v-if="expense.funding_source_id === 1"><v-icon>mdi-check</v-icon></span>
                    <span v-if="expense.funding_source_id === 2"><v-icon>mdi-close</v-icon></span>
                  </td>
                  <td v-if="phaseType == 'reporting' && $store.state.auth.user.user_functions[8].user_type_id !== 1">
                    <v-btn style="height: 24px;padding:0;margin:1px;" class="small" color="success" v-on:click="updateModal(proj, proj.project_works[workIndex], expense)">
                            <v-icon style="font-size: 19px;">mdi-update</v-icon>
                          </v-btn>
                  </td>
                  <td v-if="phaseType == 'reporting' && $store.state.auth.user.user_functions[8].user_type_id === 3">
                    <v-btn style="height: 24px;padding:0;margin:1px;" color="primary" v-on:click="dropModal('Expense', 'Expense ' + expense.expense_amount + 'mLAK' + ' (' + new Date( expense.createdAt).toLocaleDateString('en-GB') + ')', expense.id, proj.id)">
                          <v-icon style="font-size: 19px;">mdi-delete</v-icon>
                        </v-btn>
                  </td>
                </tr>
              </template>

                <!--<tr>
                  <td>
                    <div v-if="proj.project_budget_contract 
                            && proj.project_budget_contract.length !== 0 
                            && proj.project_budget_contract[0].budget_expenses.length !== 0">
                      <div v-for="x in proj.project_budget_contract[0].budget_expenses">
                          {{ x.work_value.toLocaleString('en-US') }}
                      </div>
                    </div>
                    <div v-if="proj.budget_expense_other_funding 
                            && proj.budget_expense_other_funding.length !== 0">
                      <div v-for="x in proj.budget_expense_other_funding">
                          {{ x.work_value.toLocaleString('en-US') }}
                      </div>
                    </div>
                  </td>

                  <td>
                    <div v-if="proj.project_budget_contract 
                            && proj.project_budget_contract.length !== 0 
                            && proj.project_budget_contract[0].budget_expenses.length !== 0">
                      <div v-for="x in proj.project_budget_contract[0].budget_expenses">
                        {{ x.amount.toLocaleString('en-US') }}
                      </div>
                    </div>
                    <div v-if="proj.budget_expense_other_funding 
                            && proj.budget_expense_other_funding.length !== 0">
                      <div v-for="x in proj.budget_expense_other_funding">
                          {{ x.amount.toLocaleString('en-US') }}
                      </div>
                    </div>
                  </td>

                  <td>
                    <div v-if="proj.project_budget_contract 
                            && proj.project_budget_contract.length !== 0 
                            && proj.project_budget_contract[0].budget_expenses.length !== 0">
                      <div v-for="x in proj.project_budget_contract[0].budget_expenses">
                          {{ new Date( x.createdAt).toLocaleDateString("en-GB") }}
                      </div>  
                    </div>
                    <div v-if="proj.budget_expense_other_funding 
                            && proj.budget_expense_other_funding.length !== 0">
                      <div v-for="x in proj.budget_expense_other_funding">
                          {{ new Date( x.createdAt).toLocaleDateString("en-GB") }}
                      </div>
                    </div>
                  </td>

                  <td>
                    <div v-if="proj.project_budget_contract 
                            && proj.project_budget_contract.length !== 0 
                            && proj.project_budget_contract[0].budget_expenses.length !== 0">
                      <div v-for="x in proj.project_budget_contract[0].budget_expenses">
                          <span class="hyperlink_document" v-on:click="download(x, proj.id)">{{ x.document_name }}</span>
                      </div>  
                    </div>
                    <div v-if="proj.budget_expense_other_funding 
                            && proj.budget_expense_other_funding.length !== 0">
                      <div v-for="x in proj.budget_expense_other_funding">
                          <span class="hyperlink_document" v-on:click="download(x, proj.id)">{{ x.document_name }}</span>
                      </div>
                    </div>
                  </td>

                  <td>
                    <div v-if="proj.project_budget_contract 
                            && proj.project_budget_contract.length !== 0 
                            && proj.project_budget_contract[0].budget_expenses.length !== 0">
                      <div v-for="x in proj.project_budget_contract[0].budget_expenses">
                          <v-icon>mdi-check</v-icon>
                      </div>  
                    </div>
                    <div v-if="proj.budget_expense_other_funding 
                            && proj.budget_expense_other_funding.length !== 0">
                      <div v-for="x in proj.budget_expense_other_funding">
                          <v-icon>mdi-close</v-icon>
                      </div>
                    </div>
                  </td>

                  <td v-if="phaseType == 'reporting' && $store.state.auth.user.user_functions[8].user_type_id !== 1 && proj.project_status_id !== 2"> 
                    <div v-if="proj.project_budget_contract 
                            && proj.project_budget_contract.length !== 0 
                            && proj.project_budget_contract[0].budget_expenses.length !== 0">
                      <div v-for="x in proj.project_budget_contract[0].budget_expenses">
                          <v-btn style="height: 24px;padding:0;margin:1px;" class="small" color="success" v-on:click="updateModal(x, proj.project_budget_contract[0].funding_source_id, proj.id)">
                            <v-icon style="font-size: 19px;">mdi-update</v-icon>
                          </v-btn>
                      </div>
                    </div>
                    <div v-if="proj.budget_expense_other_funding 
                            && proj.budget_expense_other_funding.length !== 0"> 
                      <div v-for="x in proj.budget_expense_other_funding">
                          <v-btn style="height: 24px;padding:0;margin:1px;" class="small" color="success" v-on:click="updateModal(x, proj.budget_expense_other_funding[0].funding_source_id, proj.id)">
                            <v-icon style="font-size: 19px;">mdi-update</v-icon>
                          </v-btn>
                      </div>
                    </div>
                  </td>

                  <td v-if="phaseType == 'reporting' && $store.state.auth.user.user_functions[8].user_type_id === 3 && proj.project_status_id !== 2">
                    <div v-if="proj.project_budget_contract 
                            && proj.project_budget_contract.length !== 0 
                            && proj.project_budget_contract[0].budget_expenses.length !== 0">
                      <div v-for="x in proj.project_budget_contract[0].budget_expenses">
                        <v-btn style="height: 24px;padding:0;margin:1px;" color="primary" 
                              v-on:click="dropModal('Expense', 'Expense ' + x.amount + 'mLAK' + ' (' + new Date( x.createdAt).toLocaleDateString('en-GB') + ')', x.id, proj.id)">
                          <v-icon style="font-size: 19px;">mdi-delete</v-icon>
                        </v-btn>
                      </div>
                    </div>
                    <div v-if="proj.budget_expense_other_funding 
                            && proj.budget_expense_other_funding.length !== 0">
                      <div v-for="x in proj.budget_expense_other_funding">
                        <v-btn style="height: 24px;padding:0;margin:1px;" color="primary" v-on:click="dropModal('Expense', 'Expense ' + x.amount + 'mLAK' + ' (' + new Date( x.createdAt).toLocaleDateString('en-GB') + ')', x.id, proj.id)">
                          <v-icon style="font-size: 19px;">mdi-delete</v-icon>
                        </v-btn>
                      </div>
                    </div>
                  </td>

                </tr>-->
              </tbody>
              <tfoot>
                <tr>
                  <td style="font-weight: bold;">{{ proj.total_work_value.toLocaleString('en-US') }}</td>
                  <td style="font-weight: bold;">{{ proj.total_payment.toLocaleString('en-US') }}</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td v-if="phaseType == 'reporting'"></td>
                  <td v-if="phaseType == 'reporting'"></td>
                </tr>
              </tfoot>
            </v-simple-table>

            <v-dialog v-model="dialog_edit" max-width="1700px" persistent :retain-focus="false">
                <ExpenseForm 
                v-if="dialog_edit"
                :expense="expense_details" 
                :formType="'editForm'" 
                :dialog.sync="dialog_edit" />
            </v-dialog>
            <v-dialog v-model="dialog_delete_expense" max-width="1700px" :retain-focus="false">
                <DeleteForm 
                  v-if="dialog_delete_expense"
                  :type="modal.type" 
                  :name="modal.name" 
                  :element="modal.element" 
                  :dialog.sync="dialog_delete_expense" 
                  @deleteMessage="getDeleteModalExpenseAnswer"/>
            </v-dialog>

          </material-card>
          </v-container>

      </v-container>
    </v-card-text>

    <v-card-actions v-if="phaseType == 'reporting' && $store.state.auth.user.user_functions[8].user_type_id !== 1">
      <v-spacer></v-spacer>
        <v-dialog v-model="dialog_add_expense" max-width="1700px" :retain-focus="false">
          <template v-slot:activator="{ on, attrs }">
              <v-btn class="add-button add-button-work" color="blue" v-bind="attrs" v-on="on" dark absolute right v-on:click="addExpense(proj, null)">
                <v-icon>mdi-plus</v-icon> 
                {{ $t('Work Performed') }}
              </v-btn>
          </template>
          <ExpenseForm 
              v-if="dialog_add_expense"
              :expense="expense_details" 
              :formType="'addForm'" 
              :dialog.sync="dialog_add_expense" />
        </v-dialog>
    </v-card-actions>


    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn v-if="formType == 'viewForm'"
        class="close-button"
        text
        v-on:click="close()"
      >
        {{ $t('Close') }}
      </v-btn>
      <v-btn v-if="formType == 'addForm' || formType == 'editForm'"
        class="close-button"
        text
        v-on:click="close_edit()"
      >
        {{ $t('Close') }}
        <v-dialog v-model="dialog_modal_message" persistent max-width="800px" :retain-focus="false">
          <MessageAlert 
              v-if="dialog_modal_message" 
              :messageProps="$store.state.messages.close" 
              :cancelProps="$store.state.messages.no" 
              :validationProps="$store.state.messages.yes" 
              :dialog.sync="dialog_modal_message" 
              @answerModal="getModalAnswer"
          />
        </v-dialog>
      </v-btn>
      <v-btn
        v-if="(formType == 'addForm' || formType == 'editForm') 
              && (!proj.national_assembly_cost || (proj.national_assembly_cost && proj.national_assembly_cost > 0) ) 
              && (!proj.contract_cost || (proj.contract_cost && proj.contract_cost > 0) ) 
              && (!proj.budget_current_year || (proj.budget_current_year && proj.budget_current_year > 0) ) 
              "
        color="white darken-1"
        style="background-color:#31c0be;"
        text
        v-on:click="save()"
      >
        {{ $t('Save') }}
      </v-btn>
    </v-card-actions>

    <v-dialog v-model="$store.state.messages.confirmationMessageAdd" persistent max-width="800px" :retain-focus="false">
        <MessageAlert 
              v-if="$store.state.messages.confirmationMessageAdd" 
              :messageProps="$store.state.messages.validation_add" 
              :validationProps="$store.state.messages.ok" 
              :dialog.sync="$store.state.messages.confirmationMessageAdd" 
          />
      </v-dialog>
      
      <v-dialog v-model="$store.state.messages.confirmationMessageUpdate" persistent max-width="800px" :retain-focus="false">
        <MessageAlert 
              v-if="$store.state.messages.confirmationMessageUpdate" 
              :messageProps="$store.state.messages.validation_update" 
              :validationProps="$store.state.messages.ok" 
              :dialog.sync="$store.state.messages.confirmationMessageUpdate" 
          />
      </v-dialog>
      
      <v-dialog v-model="$store.state.messages.confirmationMessageDelete" persistent max-width="800px" :retain-focus="false">
        <MessageAlert 
              v-if="$store.state.messages.confirmationMessageDelete" 
              :messageProps="$store.state.messages.confirm_deletion" 
              :validationProps="$store.state.messages.ok" 
              :dialog.sync="$store.state.messages.confirmationMessageDelete" 
          />
      </v-dialog>
      
  </v-card>
</template>

<script>
  export default {
    name: 'FinanceForm',
    props: {
      budget: {
        type: Object
      },
      formType: {
        type: String
      },
      phaseType: {
        type: String
      }
    },
    data: () => ({
      dialog_modal_message: false,
      dialog_view: false,
      dialog_add_expense: false,
      add_fund_flag: false,
      dialog_edit: false,
      dialog_delete_expense: false,
      dialog_delete_fund: false,
      proj: {},
      expense_details: {},
      modal: {
        type:'',
        name:'',
        element: { expense_id: 0}
      }
    }),
    computed: {
      projectCompletedList() {
        return this.$store.state.projects.projectCompletedList;
      },
      projectOnGoingList() {
        return this.$store.state.projects.projectOnGoingList;
      },
    },
    created: function(){
      this.proj = this.budget;
      //console.log('this.proj.project_works', this.proj.project_works);
      this.numberRules = [ v => v > 0 || this.getTranslation('Positive Number is required') ];
    },
    watch: { 
      projectOnGoingList: function(value){
        this.proj = this.projectOnGoingList.filter(o => o.id === this.budget.id)[0];
      },
      'proj.national_assembly_cost': function(value){
        if(value === 0){
          this.proj.national_assembly_cost = '';
        }
      },
      'proj.contract_cost': function(value){
        if(value === 0){
          this.proj.contract_cost = '';
        }
      },
      'proj.budget_current_year': function(value){
        if(value === 0){
          this.proj.budget_current_year = '';
        }
      }
    },
    methods: {
      getTranslation(val) {
        return this.$t(val);
      },
      isSameWorkBelow(workIndex, expenseIndex) {
        const currentWork = this.proj.project_works[workIndex];
        const nextExpense = currentWork.work_expenses[expenseIndex + 1];

        // Vérifie si la dépense suivante existe et concerne le même travail
        return nextExpense ? nextExpense.work_id === currentWork.id : false;
      },
      close: function(){
        if(this.phaseType == 'planning'){
          this.$store.dispatch('projects/getProjectContractorList');
        }
        if(this.phaseType == 'reporting'){
          this.$store.dispatch('projects/getProjectOnGoingList');
        }
        this.$emit('update:dialog', false)
      },
      close_edit: function(){
        this.dialog_modal_message = true;
      },
      getModalAnswer(value){
        if(value){
          if(this.phaseType == 'planning'){
            this.$store.dispatch('projects/getProjectContractorList');
          }
          if(this.phaseType == 'reporting'){
            this.$store.dispatch('projects/getProjectOnGoingList');
          }
          this.$emit('update:dialog', false)
        }
      },
      newFundForm: function(project){
        this.add_fund_flag = true;
      },
      saveNewFund: function(){
        var parameter = {
          amount: this.proj.other_budget_amount,
          project_id: this.proj.id
        }
        this.$store.dispatch('projects/addNewFund',parameter);
        this.add_fund_flag = false;
      },
      closeNewFundForm: function(){
        this.add_fund_flag = false;
      },
      updateModal: function(project, project_work, expense){
        //expense.project_id = project_id;
        //expense.project_budget_id = funding_source_id; //TEMPORARY
        
        this.expense_details = {
          'project_id': project.id,
          'project_work': project_work,
          'project_work_id': project_work.id,
          'expense' :expense
        }

        this.dialog_edit = true;
      },
      addExpense: function(project, project_work){
        if(project_work !== null){
          this.expense_details = {
            'project_id': project.id,
            'project_work': project_work,
            'project_work_id': project_work.id
          };
        }else{
          this.expense_details = {
          'project_id': project.id,
          'project_work': null,
          'project_work_id': null
        };
        }
        this.dialog_add_expense = true;
      },
      download:function(doc, project_id){
        doc.project_id = project_id;
        //this.$store.dispatch('projects/downloadExpenseDocument', doc);
        this.$store.dispatch('projects/downloadDocument', doc);
      },
      save: function(){
        if(this.phaseType == 'planning'){
          if(this.proj.national_assembly_cost === ''){
            this.proj.national_assembly_cost = 0;
          }
          if(this.proj.contract_cost === ''){
            this.proj.contract_cost = 0;
          }
          if(this.proj.budget_current_year === ''){
            this.proj.budget_current_year = 0;
          }
          this.$store.dispatch('projects/updateBudget',this.proj);
          this.$store.dispatch('projects/getProjectContractorList');
          //this.$store.dispatch('projects/getProjectOnGoingList');
        }
        if(this.phaseType == 'reporting'){
          this.$store.dispatch('projects/getProjectOnGoingList');
        }
        this.$emit('update:dialog', false)
      },
      getDeleteModalExpenseAnswer(value){
        if(value){
          this.$store.dispatch('projects/deleteExpense',this.modal);
        }
      },
      getDeleteModalFundAnswer(value){
        if(value){
          this.$store.dispatch('projects/deleteFund',this.modal);
        }
      },
      dropModal: function(type, name, expense_or_fund_id, project_id){
        if(type === 'Expense'){
          this.dialog_delete_expense = true;
        }else if(type === 'Fund'){
          this.dialog_delete_fund = true;
        }
        this.modal.type = type;
        this.modal.name = name;
        this.modal.id = expense_or_fund_id;
        this.modal.project_id = project_id;
      }
    },
  }
</script>
<style scoped>
  @media (min-width: 1264px){
    .container {
      max-width: 1560px;
    }
  }
  .no-border td {
    border-bottom: none !important;
  }
  .hyperlink_document {
    cursor:pointer;
    text-decoration: underline;
    margin-left:5px;
  }   
  .expense-table > .v-data-table__wrapper > table > thead > tr > th,
  .expense-table > .v-data-table__wrapper > table > tbody > tr > td,
  .expense-table > .v-data-table__wrapper > table > tfoot > tr > td{
    text-align: center !important;
  }
  .expense-table > .v-data-table__wrapper > table > thead > tr > th:nth-child(1),
  .expense-table > .v-data-table__wrapper > table > tbody > tr > td:nth-child(1),
  .expense-table > .v-data-table__wrapper > table > tfoot > tr > td:nth-child(1){
    width: 12%;
  }
  .expense-table > .v-data-table__wrapper > table > thead > tr > th:nth-child(2),
  .expense-table > .v-data-table__wrapper > table > tbody > tr > td:nth-child(2),
  .expense-table > .v-data-table__wrapper > table > tfoot > tr > td:nth-child(2){
    width: 8%;
  }
  .expense-table > .v-data-table__wrapper > table > thead > tr > th:nth-child(3),
  .expense-table > .v-data-table__wrapper > table > tbody > tr > td:nth-child(3),
  .expense-table > .v-data-table__wrapper > table > tfoot > tr > td:nth-child(3){
    width: 10%;
  }
  .expense-table > .v-data-table__wrapper > table > thead > tr > th:nth-child(4),
  .expense-table > .v-data-table__wrapper > table > tbody > tr > td:nth-child(4),
  .expense-table > .v-data-table__wrapper > table > tfoot > tr > td:nth-child(4){
    width: 15%;
  }
  .expense-table > .v-data-table__wrapper > table > thead > tr > th:nth-child(5),
  .expense-table > .v-data-table__wrapper > table > tbody > tr > td:nth-child(5),
  .expense-table > .v-data-table__wrapper > table > tfoot > tr > td:nth-child(5){
    width: 15%;
  }
  .expense-table > .v-data-table__wrapper > table > thead > tr > th:nth-child(6),
  .expense-table > .v-data-table__wrapper > table > tbody > tr > td:nth-child(6),
  .expense-table > .v-data-table__wrapper > table > tfoot > tr > td:nth-child(6){
    width: 15%;
  }
  .expense-table > .v-data-table__wrapper > table > thead > tr > th:nth-child(7),
  .expense-table > .v-data-table__wrapper > table > tbody > tr > td:nth-child(7),
  .expense-table > .v-data-table__wrapper > table > tfoot > tr > td:nth-child(7){
    width: 5%;
  }
  tr:nth-child(even), tr:nth-child(odd) {
    background-color: transparent;
  }
  .add-button {
    position: relative;
    bottom:5px;
  }
  .add-button-other-fund {
    width: 110px;
    font-size: 10px;
    height: 30px !important;
    margin-left: 15px;
  }
  .add-button-other-fund > .v-icon {
    font-size: 20px;
  }
  /*.add-button-expense{
    width: 70px;
    font-size: 10px;
    height: 30px !important;
    margin-left: 15px;
  }*/
  .add-button-expense > .v-icon {
    font-size: 20px;
  }
  /*.add-button-work{
    width: 110px;
    font-size: 10px;
    height: 30px !important;
  }*/
  .add-button-work > .v-icon {
    font-size: 20px;
  }
</style>